import { Effect, Either } from "effect";

/** Preserve typed Effect failures at TanStack Query's Promise boundary. */
export async function runEffectQuery<A, E>(
  program: Effect.Effect<A, E>,
  signal: AbortSignal,
): Promise<A> {
  const result = await Effect.runPromise(Effect.either(program), { signal });

  if (Either.isLeft(result)) throw result.left;

  return result.right;
}

/** Preserve typed Effect failures at TanStack Mutation's Promise boundary. */
export async function runEffectMutation<A, E>(
  program: Effect.Effect<A, E>,
): Promise<A> {
  const result = await Effect.runPromise(Effect.either(program));

  if (Either.isLeft(result)) throw result.left;

  return result.right;
}
